import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { HashRouter, Route, Routes } from 'react-router-dom';
import Inhaltsverzeichnis from './components/inhaltsverzeichnis';
import InhaltsverzeichnisFav from './components/inhaltsverzeichnis_fav';
import InhaltsverzeichnisKateg from './components/inhaltsverzeichnis_kateg';
import LiedDetail from './components/liedseite';
import LiedBearbeiten from './components/liedBearbeiten';
import LiedHinzufuegen from './components/liedHinzufuegen';
import Suchseite from './components/suchseite';
import Navbar from './components/navbar';
import { startOfflineSync } from './liederStore';
import { startTracking } from './tracking';

function App() {
  return (
    <Routes>
      <Route path='/' element={<Inhaltsverzeichnis />} />
      <Route path='/lied/:id' element={<LiedDetail />} />
      <Route path='/favoriten' element={<InhaltsverzeichnisFav />} />
      <Route path='/kategorie' element={<InhaltsverzeichnisKateg />} />
      <Route path='/suche' element={<Suchseite />} />
      <Route path='/bearbeiten' element={<LiedBearbeiten />} />
      <Route path='/hinzufuegen' element={<LiedHinzufuegen />} />
    </Routes>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HashRouter>

    <App />
      <Navbar />
  </HashRouter>
);

startOfflineSync();
startTracking();

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .catch((err) => console.error('Service Worker konnte nicht registriert werden', err));
  });
}
